import React from "react";

type Props = {};

// eslint-disable-next-line no-empty-pattern
export default function PlusIcon(props: Props) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.99997 2.91507V13.0849"
        stroke="#7A7A7A"
        strokeWidth="1.75"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M2.91504 8H13.0849"
        stroke="#7A7A7A"
        strokeWidth="1.75"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
    </svg>
  );
}
